var _circle, _circle2, _circle3, _circle4, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlumni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8239,
    cy: 3.17647,
    r: 2.42647,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8239,
    cy: 14.8234,
    r: 2.42647,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.17647,
    cy: 3.17647,
    r: 2.42647,
    stroke: "black",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.17647,
    cy: 14.8234,
    r: 2.42647,
    stroke: "black",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.87006,
    y1: 12.9697,
    x2: 12.97,
    y2: 4.86967,
    stroke: "black",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 11.4551,
    y2: -0.75,
    transform: "matrix(-0.707104 -0.707109 -0.707109 0.707104 12.5996 13.5)",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumni);
export default __webpack_public_path__ + "static/media/Alumni.d4b63a7d09100e32202631acac4c895b.svg";
export { ForwardRef as ReactComponent };